<div class="item-panel">
	<div class="heading strong"><b>{{brand.mechName}}</b></div>
	<div class="content dark nopad">
		<div *ngIf="components" class="component-list">
			<div *ngIf="components.engine && components.engine.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'engine'">Engine</div>
				<div class="group-components">
					<i *ngFor="let engine of components.engine" (click)="selectComponent(engine)"
						[class.status-ok-fg]="(engine.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(engine.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(engine.state?.filtered_hi | hilevel) === 4"
						[class.highlight]="engine.highlight"
						[class.selected]="selectedcomponent === engine" class="icon-motor"
						title="{{engine.name}} ({{engine.id}}) {{lookupLRU(engine)}}"></i>
				</div>
			</div>
			<div *ngIf="components.tach && components.tach.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'tach'">Tach</div>
				<div class="group-components">
					<i *ngFor="let tach of components.tach" (click)="selectComponent(tach)"
						[class.status-ok-fg]="(tach.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(tach.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(tach.state?.filtered_hi | hilevel) === 4"
						[class.highlight]="tach.highlight"
						[class.selected]="selectedcomponent === tach" class="icon-gauge"
						title="{{tach.name}} ({{tach.id}}) {{lookupLRU(tach)}}"></i>
				</div>
			</div>
			<div *ngFor="let shaft of components.shaft | isnotghost" class="group">
				<div class="group-title" [class.selected]="selectedcomponent === shaft || selectedshaft === shaft">
					{{shaft.name}}</div>
				<div class="group-components">
					<i (click)="selectComponent(shaft)" [class.selected]="selectedcomponent === shaft"
						[class.highlight]="shaft.highlight"
						[class.status-ok-fg]="(shaft.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(shaft.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(shaft.state?.filtered_hi | hilevel) === 4" class="icon-shaft"
						title="{{shaft.name}} ({{shaft.id}}) {{lookupLRU(shaft)}}"></i>
					<i *ngFor="let gear of shaft.gear" (click)="selectComponent(gear, shaft)"
						[class.selected]="selectedcomponent === gear"
						[class.highlight]="gear.highlight"
						[class.status-ok-fg]="(gear.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(gear.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(gear.state?.filtered_hi | hilevel) === 4" class="icon-cog"
						title="{{gear.name}} ({{gear.id}}) {{lookupLRU(gear)}}"></i>
					<i *ngFor="let bearing of shaft.bearing" (click)="selectComponent(bearing, shaft)"
						[class.selected]="selectedcomponent === bearing"
						[class.highlight]="bearing.highlight"
						[class.status-ok-fg]="(bearing.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(bearing.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(bearing.state?.filtered_hi | hilevel) === 4" class="icon-bearing"
						title="{{bearing.name}} ({{bearing.id}}) {{lookupLRU(bearing)}}"></i>
					<i *ngFor="let motor of shaft.motor" (click)="selectComponent(motor, shaft)"
						[class.selected]="selectedcomponent === motor"
						[class.highlight]="motor.highlight"
						[class.status-ok-fg]="(motor.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(motor.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(motor.state?.filtered_hi | hilevel) === 4" class="icon-motor"
						title="{{motor.name}} ({{motor.id}}) {{lookupLRU(motor)}}"></i>
				</div>
			</div>
			<div *ngFor="let motorshaft of components.motorshaft" class="group">
				<div class="group-title" [class.selected]="selectedcomponent === motorshaft || selectedshaft === motorshaft">
					{{motorshaft.name}}</div>
				<div class="group-components">
					<i (click)="selectComponent(motorshaft)" [class.selected]="selectedcomponent === motorshaft"
						[class.highlight]="motorshaft.highlight"
						[class.status-ok-fg]="(motorshaft.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(motorshaft.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(motorshaft.state?.filtered_hi | hilevel) === 4" class="icon-shaft"
						title="{{motorshaft.name}} ({{motorshaft.id}}) {{lookupLRU(motorshaft)}}"></i>
					<i *ngFor="let motor of motorshaft.motor" (click)="selectComponent(motor, motorshaft)"
						[class.selected]="selectedcomponent === motor"
						[class.highlight]="motor.highlight"
						[class.status-ok-fg]="(motor.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(motor.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(motor.state?.filtered_hi | hilevel) === 4" class="icon-motor"
						title="{{motor.name}} ({{motor.id}}) {{lookupLRU(motor)}}"></i>
					<i *ngFor="let bearing of motorshaft.bearing" (click)="selectComponent(bearing, motorshaft)"
						[class.selected]="selectedcomponent === bearing"
						[class.highlight]="bearing.highlight"
						[class.status-ok-fg]="(bearing.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(bearing.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(bearing.state?.filtered_hi | hilevel) === 4"
						[ngClass]="bearing.icon ? ('icon-' + bearing.icon) : 'icon-bearing'"
						title="{{bearing.name}} ({{bearing.id}}) {{lookupLRU(bearing)}}"></i>
				</div>
			</div>
			<div *ngIf="components.current && components.current.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'current'">Current</div>
				<div class="group-components">
					<i *ngFor="let current of components.current" (click)="selectComponent(current)"
						[class.selected]="selectedcomponent === current"
						[class.highlight]="current.highlight"
						[class.status-ok-fg]="(current.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(current.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(current.state?.filtered_hi | hilevel) === 4" class="icon-flash"
						title="{{current.name}} ({{current.id}}) {{lookupLRU(current)}}"></i>
				</div>
			</div>
			<div *ngIf="components.impact && components.impact.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'impact'">Impact</div>
				<div class="group-components">
					<i *ngFor="let impact of components.impact" (click)="selectComponent(impact)"
						[class.selected]="selectedcomponent === impact"
						[class.highlight]="impact.highlight"
						[class.status-ok-fg]="(impact.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(impact.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(impact.state?.filtered_hi | hilevel) === 4" class="icon-sensor"
						title="{{impact.name}} ({{impact.id}}) {{lookupLRU(impact)}}"></i>
				</div>
			</div>
			<div *ngIf="components.flutter && components.flutter.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'flutter'">Flutter</div>
				<div class="group-components">
					<i *ngFor="let flutter of components.flutter" (click)="selectComponent(flutter)"
						[class.selected]="selectedcomponent === flutter"
						[class.highlight]="flutter.highlight"
						[class.status-ok-fg]="(flutter.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(flutter.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(flutter.state?.filtered_hi | hilevel) === 4" class="icon-flutter"
						title="{{flutter.name}} ({{flutter.id}}) {{lookupLRU(flutter)}}"></i>
				</div>
			</div>
			<div *ngIf="components.tracker && components.tracker.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'tracker'">Trackers</div>
				<div class="group-components">
					<i *ngFor="let tracker of components.tracker" (click)="selectComponent(tracker)"
						[class.selected]="selectedcomponent === tracker"
						[class.highlight]="tracker.highlight"
						[class.status-ok-fg]="(tracker.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(tracker.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(tracker.state?.filtered_hi | hilevel) === 4" class="icon-camera"
						title="{{tracker.name}} ({{tracker.id}}) {{lookupLRU(tracker)}}"></i>
				</div>
			</div>
			<div *ngIf="components.sensor && components.sensor.length" class="group">
				<div class="group-title" [class.selected]="selectedcomponent?.type === 'sensor'">Sensors</div>
				<div class="group-components">
					<i *ngFor="let sensor of components.sensor" (click)="selectComponent(sensor)"
						[class.selected]="selectedcomponent === sensor"
						[class.highlight]="sensor.highlight"
						[class.status-ok-fg]="(sensor.state?.filtered_hi | hilevel) === 1"
						[class.status-warning-fg]="(sensor.state?.filtered_hi | hilevel) === 3"
						[class.status-error-fg]="(sensor.state?.filtered_hi | hilevel) === 4" class="icon-sensor"
						title="{{sensor.name}} ({{sensor.id}}) {{lookupLRU(sensor)}}"></i>
				</div>
			</div>
			<div class="group">
				<div class="group-title" [class.selected]="selectedmaintenance">Maintenance</div>
				<div class="group-components">
					<i *ngIf="!asset.is_fixed && components.alt_engine_name && (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master')"
						(click)="selectMaintenance('engine')" [class.selected]="selectedmaintenance === 'engine'" class="icon-motor"
						title="Engine maintenance"></i>
					<i (click)="selectMaintenance('log')" [class.selected]="selectedmaintenance === 'log'" class="icon-calendar"
						title="Maintenance log"></i>
					<i *ngIf="!asset.is_fixed" (click)="selectMaintenance('firmware')" [class.selected]="selectedmaintenance === 'firmware'"
						class="icon-search" title="Firmware"></i>
					<i (click)="selectMaintenance('alerts')" [class.selected]="selectedmaintenance === 'alerts'" class="icon-attention"
						[class.status-error-fg]="asset.alertcount > 0" [class.status-ok-fg]="asset.alertcount === 0" title="Alert log"></i>
					<i *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'"
						(click)="selectMaintenance('connections')" [class.selected]="selectedmaintenance === 'connections'" class="icon-doc"
						title="Connection log"></i>
					<i *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'"
						(click)="selectMaintenance('useraccess')" [class.selected]="selectedmaintenance === 'useraccess'" class="icon-users"
						title="User access"></i>
					<!-- TODO: temporarily turning off OBCU log for regular users -->
					<i *ngIf="api.user.role === 'admin' || api.user.role === 'master'"
						(click)="selectMaintenance('commfailures')" [class.selected]="selectedmaintenance === 'commfailures'" class="icon-link"
						[class.status-error-fg]="asset.latest_obcu_failures > 0" [class.status-ok-fg]="asset.latest_assembly_version && asset.latest_obcu_failures === 0" title="Sensor failures"></i>
				</div>
			</div>
		</div>
		<div *ngIf="selectedcomponent" class="component-detail">
			<div class="component-summary">
				{{selectedcomponent.type | componentname}}: {{selectedcomponent.name}}
				<span *ngIf="selectedcomponent.state">
					&nbsp; HI: {{selectedcomponent.state.hi | number : ".5-5" }}&nbsp; Filtered HI:
					{{selectedcomponent.state.filtered_hi | number : ".5-5"}}
					<span *ngIf="selectedcomponent.state.rul">&nbsp; RUL: {{selectedcomponent.state.rul | number : ".1-1"}}</span>
				</span>
			</div>
			<ul ngbNav #nav="ngbNav" class="nav-tabs">
				<li ngbNavItem>
					<a ngbNavLink>HI Trend</a>
					<ng-template ngbNavContent>
						<app-trend-hi [asset]="asset" [fleet]="fleet" [component]="selectedcomponent" [rul_capacity_factor]="components.rul_capacity_factor"></app-trend-hi>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>CI Trend</a>
					<ng-template ngbNavContent>
						<app-trend-ci [asset]="asset" [fleet]="fleet" [component]="selectedcomponent"></app-trend-ci>
					</ng-template>
				</li>
				<li ngbNavItem *ngIf="selectedcomponent.type !== 'engine' && selectedcomponent.type !== 'flutter' && selectedcomponent.type !== 'tracker'">
					<a ngbNavLink>Component Detail</a>
					<ng-template ngbNavContent>
						<app-component-detail [asset]="asset" [fleet]="fleet" [component]="selectedcomponent"
							[shaft]="selectedshaft"></app-component-detail>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>Fleet Comparison</a>
					<ng-template ngbNavContent>
						<app-fleet-comparison [asset]="asset" [fleet]="fleet" [component]="selectedcomponent">
						</app-fleet-comparison>
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="nav"></div>
		</div>
		<div *ngIf="selectedmaintenance === 'engine'" class="component-detail">
			<app-mech-engine [asset]="asset" [fleet]="fleet" [components]="components"></app-mech-engine>
		</div>
		<div *ngIf="selectedmaintenance === 'log'" class="component-detail">
			<app-mech-maintenance [asset]="asset" [fleet]="fleet" [components]="components"></app-mech-maintenance>
		</div>
		<div *ngIf="selectedmaintenance === 'firmware'" class="component-detail">
			<app-mech-firmware [asset]="asset" [fleet]="fleet" [components]="components"></app-mech-firmware>
		</div>
		<div *ngIf="selectedmaintenance === 'alerts'" class="component-detail">
			<app-mech-alerts [asset]="asset" [fleet]="fleet" [components]="components"></app-mech-alerts>
		</div>
		<div *ngIf="selectedmaintenance === 'connections'" class="component-detail" class="component-detail">
			<app-mech-log [asset]="asset" [fleet]="fleet"></app-mech-log>
		</div>
		<div *ngIf="selectedmaintenance === 'commfailures'" class="component-detail" class="component-detail">
			<app-mech-comm-failures [asset]="asset" [fleet]="fleet"></app-mech-comm-failures>
		</div>
		<div *ngIf="selectedmaintenance === 'useraccess'" class="component-detail" class="component-detail">
			<app-mech-user-access [asset]="asset" [fleet]="fleet"></app-mech-user-access>
		</div>
		<div *ngIf="!selectedcomponent && !selectedmaintenance" class="component-detail" style="padding: 50px;">
			Select a component above to view diagnostic information
		</div>
	</div>
</div>